import request from '../main';

const service = ""

//其他第三方请求API
class RegulationsApi {
    private url: string = service + '/regulations';

    get(id: number){
        return request({
            url: this.url + '/get-regulations',
            method: 'get',
            params: {
                id: id,
            }
        })
    }
    page(args: any) {
        return request({
            url: this.url + '/page-regulations',
            method: 'get',
            params: args
        })
    }


    edit(args: any) {
        return request({
            url: this.url + '/edit-regulations',
            method: 'post',
            data: args
        })
    }

    delete(ids: any) {
        return request({
            url: this.url + '/delete-regulations',
            method: 'post',
            data: {
                ids: ids,
            }
        })
    }

    share(ids: string, shareStatus: number) {
        return request({
            url: this.url + '/share-regulations',
            method: 'post',
            data: {
                ids: ids,
                shareStatus: shareStatus
            }
        })
    }

    examine(ids: any, status: number) {
        return request({
            url: this.url + '/examine-regulations',
            method: 'post',
            data: {
                ids: ids,
                status: status
            }
        })
    }
}

const regulationsApi = new RegulationsApi();
export default regulationsApi;